
function ErrorSign() {
  return (
    <div className='div--error'>
        <div className='div--error-sign'>⚠</div>
        Oops! There was an error loading the data, please try again later.
    </div>
  )
}

export default ErrorSign;